import React from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from '@phosphor-icons/react';

const SliderHero = () => {
  const sliderVariants = {
    animate: {
      x: ['-50%', '-0%'], // Move from 0% to -100% to scroll the whole div
      transition: {
        x: {
          repeat: Infinity, // Repeat infinitely
          repeatType: 'loop', // Seamless looping
          duration: 20, // Control the scrolling speed
          ease: 'linear', // Maintain consistent scrolling speed
        },
      },
    },
  };

  return (
    <div className="overflow-hidden bg-light border w-full m-auto border-red-200/50 shadow-lg rounded-3xl">
      <div className="flex">
        {/* Wrapping motion div in a non-moving container for smoother motion */}
        <motion.div
          className="whitespace-nowrap heading-36 text-primary flex py-10 px-2 gap-12"
          variants={sliderVariants}
          animate="animate"
        >
          {/* This is the sliding content that repeats */}
          <div className="flex items-center gap-10">
            No Hidden Cost
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            75% More Savings
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            100% Transparent Pricing
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            No Hidden Cost
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            75% More Savings
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            100% Transparent Pricing
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            No Hidden Cost
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            75% More Savings
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
            100% Transparent Pricing
            <Sparkle size={32} color="#ffc4d3" weight="fill" className="mx-2" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SliderHero;
